var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.209,
    height: 17.209,
    viewBox: "0 0 17.209 17.209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Download",
    d: "M18.349,12.326a.86.86,0,0,0-.86.86v3.442a.86.86,0,0,1-.86.86H4.581a.86.86,0,0,1-.86-.86V13.186a.86.86,0,1,0-1.721,0v3.442a2.581,2.581,0,0,0,2.581,2.581H16.628a2.581,2.581,0,0,0,2.581-2.581V13.186A.86.86,0,0,0,18.349,12.326ZM9.994,13.8a.86.86,0,0,0,.284.181.809.809,0,0,0,.654,0,.86.86,0,0,0,.284-.181l3.442-3.442a.864.864,0,1,0-1.222-1.222l-1.97,1.979V2.86a.86.86,0,1,0-1.721,0v8.252L7.774,9.133a.864.864,0,0,0-1.222,1.222Z",
    transform: "translate(-2 -2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7dfed3bd950b561557b563b07127fc19.svg";
export { ForwardRef as ReactComponent };